// external
import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

// models, types
import { ICard } from '@/interfaces/Card';
import { VuexAction } from '@/@types/index.d';

// store
import {
	GET_ACTIVE_CARD_INDEX,
	GET_CARDS,
	GET_CARD_CLICK_REPORT,
	GET_THEME,
	NEXT_CARD,
	SEND_REPORT,
} from '@/store/types';

// components
import { IReport } from '@/interfaces/IReport';
import Card from '../card/Card.vue';

@Component({
	components: {
		Card,
	},
})
export default class LargeCard extends Vue {
	@Getter(GET_THEME) getTheme!: string;

	@Getter(GET_CARDS) getCards!: ICard[];

	@Getter(GET_ACTIVE_CARD_INDEX) getActiveCardIndex!: number;

	@Getter(GET_CARD_CLICK_REPORT) getCardClickedReport!: IReport;

	@Action(NEXT_CARD) nextCard!: VuexAction<void>;

	@Action(SEND_REPORT) sendReport!: VuexAction<IReport>;

	public exitIndex: number = -1;

	nextCardEvent() {
		this.exitIndex = this.getActiveCardIndex;
		this.nextCard();
		this.sendReport(this.getCardClickedReport);
		// Remove the mealcard-exit class to make 2 item mixups look good.
		setTimeout(() => {
			const exitItem = document.getElementsByClassName(
				'mxr-carousel-item-exit'
			);
			if (exitItem && exitItem.length) {
				for (let i = 0; i < exitItem.length; i += 1) {
					exitItem[i].classList.remove('mxr-carousel-item-exit');
				}
			}
		}, 500);
	}
}
